const currencyFallback = {
    compact: {
        zero: '₽',
        one: '₽',
        few: '₽',
        many: '₽',
        separator: ''
    },
    full: {
        zero: '₽',
        one: '₽',
        few: '₽',
        many: '₽',
        separator: ''
    }
};

function endingCurrency(price) {
    if (price >= 11 && price <= 14) return 'many';

    if (price % 10 === 0) return 'zero';
    else if (price % 10 === 1) return 'one';
    else if (price % 10 >= 2 && price % 10 <= 4) return 'few';
    else return 'many';
}

export function shortCurrency(currency, price) {
    if (!currency) currency = currencyFallback

    const compact = currency.compact || currencyFallback.compact;
    const ending = endingCurrency(price);

    return `${compact.separator}${compact[ending]}`;
}

export function longCurrency(currency, price) {
    if (!currency) currency = currencyFallback

    const full = currency.full || currencyFallback.full;
    const ending = endingCurrency(price);

    return `${full.separator}${full[ending]}`;
}
